import React, { useState, useEffect, useContext } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Avatar,
  Menu,
  MenuItem,
  IconButton,
  Divider,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout, sessionPing } from "../../services/webServices";
import { logout as logoutAction } from "../../store/slices/authSlice";
import { clearCurrentProject } from "../../store/slices/projectSlice";
import { resetApplicationSetup } from "../../store/slices/applicationSetupSlice";
import { resetTrustIndex } from "../../store/slices/trustIndexSlice";
import { resetRisk } from "../../store/slices/riskSlice";
import { resetMetrics } from "../../store/slices/metricsSlice";
import { resetDataset } from "../../store/slices/datasetSlice";
import { resetTestEvaluation } from "../../store/slices/testEvaluationSlice";
import { resetTestScore } from "../../store/slices/testScoreSlice";
import { useSidebar } from "./DashboardLayout";
import { SidebarContext } from "./DashboardLayout";
import Logo from "../../asserts/logo/Logo.svg";

function AppHeader() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // Make sidebar context optional - use 0 if not within SidebarProvider
  const sidebarContext = useContext(SidebarContext);
  const sidebarWidth = sidebarContext?.sidebarWidth || 0;
  const [anchorEl, setAnchorEl] = useState(null);
  const [username, setUsername] = useState("");
  const open = Boolean(anchorEl);

  // Fetch username from session
  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const response = await sessionPing();
        if (response.data.valid && response.data.user) {
          setUsername(response.data.user.username || "");
        }
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };
    fetchUserInfo();
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleLogout = async () => {
    // Helper to clear all Redux state
    const clearAllState = () => {
      dispatch(logoutAction());
      dispatch(clearCurrentProject());
      dispatch(resetApplicationSetup());
      dispatch(resetTrustIndex());
      dispatch(resetRisk());
      dispatch(resetMetrics());
      dispatch(resetDataset());
      dispatch(resetTestEvaluation());
      dispatch(resetTestScore());
    };

    try {
      await logout();
      // Clear all Redux state
      clearAllState();
      handleClose();
      navigate("/");
    } catch (error) {
      console.error("Logout error:", error);
      // Still clear Redux state even if API fails
      clearAllState();
      handleClose();
      navigate("/");
    }
  };

  const getInitial = () => (username ? username.charAt(0).toUpperCase() : "U");

  return (
    <AppBar
      elevation={0}
      position="fixed"
      sx={{
        ml: `${sidebarWidth}px`,
        bgcolor: "#fff",
        color: "#111",
        borderBottom: "1px solid #eeeeeeff",
        zIndex: 1200,
        transition: "margin-left 0.3s ease",
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        {/* Company Logo on left side */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <img
            src={Logo}
            // alt="ValidAite Logo"
            style={{ height: 42, marginRight: 8 }}
          />
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, color: "#1976d2", letterSpacing: 0.5 }}
          >
            {/* ValidAite */}
          </Typography>
        </Box>

        {/*  User avatar & menu */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <Avatar
              sx={{
                width: 32,
                height: 32,
                cursor: "pointer",
                bgcolor: "#1976d2",
              }}
            >
              {getInitial()}
            </Avatar>
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            PaperProps={{
              elevation: 3,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <Box sx={{ px: 2, py: 1.5, minWidth: 200 }}>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mb: 0.5 }}
              >
                Signed in as
              </Typography>
              <Typography variant="body1" fontWeight="bold">
                {username || "User"}
              </Typography>
            </Box>
            <Divider />
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default AppHeader;

// import React, { useState, useEffect } from "react";
// import { AppBar, Toolbar, Typography, Box, Avatar, Menu, MenuItem, IconButton, Divider } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import { logout, sessionPing } from "../../services/webServices";
// import { useSidebar } from "./DashboardLayout";

// function AppHeader() {
//   const navigate = useNavigate();
//   const { sidebarWidth } = useSidebar();
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [username, setUsername] = useState("");
//   const open = Boolean(anchorEl);

//   // Fetch username from session
//   useEffect(() => {
//     const fetchUserInfo = async () => {
//       try {
//         const response = await sessionPing();
//         if (response.data.valid && response.data.user) {
//           setUsername(response.data.user.username || "");
//         }
//       } catch (error) {
//         console.error("Error fetching user info:", error);
//       }
//     };
//     fetchUserInfo();
//   }, []);

//   const handleClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   const handleLogout = async () => {
//     try {
//       await logout();
//       handleClose();
//       navigate("/");
//     } catch (error) {
//       console.error("Logout error:", error);
//       // Navigate to login even if logout API fails
//       handleClose();
//       navigate("/");
//     }
//   };

//   // Get first letter of username (uppercase)
//   const getInitial = () => {
//     if (username) {
//       return username.charAt(0).toUpperCase();
//     }
//     return "U";
//   };

//   return (
//     <AppBar
//       elevation={0}
//       position="fixed"
//       sx={{
//         ml: `${sidebarWidth}px`,
//         bgcolor: "#fff",
//         color: "#111",
//         borderBottom: "1px solid #eee",
//         zIndex: 1200,
//         transition: "margin-left 0.3s ease"
//       }}
//     >
//       <Toolbar>
//         <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 600 }}></Typography>
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//           <IconButton
//             onClick={handleClick}
//             size="small"
//             sx={{ ml: 2 }}
//             aria-controls={open ? "account-menu" : undefined}
//             aria-haspopup="true"
//             aria-expanded={open ? "true" : undefined}
//           >
//             <Avatar sx={{ width: 32, height: 32, cursor: "pointer", bgcolor: "#1976d2" }}>
//               {getInitial()}
//             </Avatar>
//           </IconButton>
//           <Menu
//             anchorEl={anchorEl}
//             id="account-menu"
//             open={open}
//             onClose={handleClose}
//             PaperProps={{
//               elevation: 3,
//               sx: {
//                 overflow: "visible",
//                 filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
//                 mt: 1.5,
//                 "& .MuiAvatar-root": {
//                   width: 32,
//                   height: 32,
//                   ml: -0.5,
//                   mr: 1,
//                 },
//                 "&:before": {
//                   content: '""',
//                   display: "block",
//                   position: "absolute",
//                   top: 0,
//                   right: 14,
//                   width: 10,
//                   height: 10,
//                   bgcolor: "background.paper",
//                   transform: "translateY(-50%) rotate(45deg)",
//                   zIndex: 0,
//                 },
//               },
//             }}
//             transformOrigin={{ horizontal: "right", vertical: "top" }}
//             anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
//           >
//             <Box sx={{ px: 2, py: 1.5, minWidth: 200 }}>
//               <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
//                 Signed in as
//               </Typography>
//               <Typography variant="body1" fontWeight="bold">
//                 {username || "User"}
//               </Typography>
//             </Box>
//             <Divider />
//             <MenuItem onClick={handleLogout}>
//               Logout
//             </MenuItem>
//           </Menu>
//         </Box>
//       </Toolbar>
//     </AppBar>
//   );
// }

// export default AppHeader;
